import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useMaintenanceContext } from '../contexts/MaintenanceContext';
import { useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';
import LoadingSpinner from './shared/LoadingSpinner';

const MaintenanceGate = ({ children }) => {
    const { user } = useContext(AuthContext);
    const location = useLocation();
    const navigate = useNavigate();
    
    // Get maintenance context safely
    let maintenanceStatus = { isEnabled: false, message: 'System is operational' };
    let isLoading = false;
    
    try {
        const context = useMaintenanceContext();
        maintenanceStatus = context.maintenanceStatus || maintenanceStatus;
        isLoading = context.isLoading || false;
    } catch (error) {
        // Maintenance context not available, continue without it
    }

    // Define public paths that don't require authentication
    const publicPaths = [
        '/',
        '/login', 
        '/register',
        '/pricing'
    ];

    // Don't block public pages
    if (publicPaths.includes(location.pathname)) {
        return children;
    }

    // If loading, show loading state
    if (isLoading) {
        return (
            <div style={{
                position: 'fixed',
                inset: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: 'rgba(0,0,0,0.2)',
                zIndex: 2000
            }}>
                <LoadingSpinner />
            </div>
        );
    }

    // If maintenance is enabled and user is not superuser, show maintenance page
    if (maintenanceStatus.isEnabled && user && !user.superuser) {
        return (
            <div className="container mt-5">
                <div className="row justify-content-center">
                    <div className="col-md-8">
                        <div className="card bg-dark text-light">
                            <div className="card-body text-center">
                                <h4 className="card-title">🔧 System Maintenance</h4>
                                <p className="card-text">
                                    {maintenanceStatus.message || 'The application is currently under maintenance. Please try again later.'}
                                </p>
                                
                                <div className="alert alert-warning">
                                    <strong>We're working to get everything back up and running as quickly as possible.</strong>
                                    <br />
                                    Please check back soon.
                                </div>

                                <div className="mt-4">
                                    <button 
                                        className="btn btn-outline-secondary"
                                        onClick={() => navigate('/')}
                                    >
                                        Go Home
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // Auth gating is handled by route-level guards (RequireAuth / RequireAuthAndEarlyAccess)

    // If all checks pass, render the children (app content)
    return children;
};

export default MaintenanceGate; 